import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";
import { CSSProperties } from "react";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.input.background,
      borderRadius: constants.radius.view,
      padding: spacing.m,
    },
    inner: {
      justifyContent: "center",
    },
    segmentedContainer: {
      display: "flex",
      flexDirection: "row",
      borderRadius: 50,
      padding: 4,
      backgroundColor: "rgba(9, 11, 31, 0.35)",
      userSelect: "none",
    },
    segment: {
      cursor: "pointer",
      padding: "8px 26px",
      borderRadius: 50,
      transition: "background 160ms ease",
    },
    segmentActive: {
      backgroundColor: theme.input.selected.background,
    },
    segmentText: {
      fontSize: 15,
      fontWeight: 600,
      color: theme.text.secondary,
    },
    segmentActiveText: {
      fontSize: 15,
      fontWeight: 700,
      color: theme.input.selected.text,
    },
    circle: {
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    circleDisabled: {
      opacity: 0.3,
      cursor: "default",
    },
    left: {
      fontSize: 16,
      fontWeight: 700,
      marginRight: spacing.xs,
    },
    right: {
      fontSize: 16,
      marginLeft: spacing.xs,
      fontWeight: 500,
    },
    counterContainer: {
      justifyContent: "space-between",
      marginLeft: spacing.xs,
      marginRight: spacing.xs,
    },
    amount: {
      userSelect: "none",
    },
    dropdown: {
      marginTop: spacing.xxs,
      position: "absolute",
      display: "flex",
      flexDirection: "column",
      width: 90,
      overflowX: "hidden",
      backgroundColor: theme.background,
      border: `1px solid ${theme.border}`,
    },
  };

  return styles;
};
